<!--
 * @Description  : 
 * @Author       : BigBigger
 * @Date         : 2022-07-12 16:28:37
 * @LastEditTime : 2025-08-14 11:44:07
 * @LastEditors  : BigBigger
-->
<template>
  <div class="class-select" v-if="detail.courseDetailMFlightManageWebVos && detail.courseDetailMFlightManageWebVos.length">
    <div class="class-select-title">选择班级：</div>
    <div class="class-select-select active" @click="showPop">
      <span class="van-ellipsis">{{name}}</span>
      <span>></span>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        title="选择班级"
        show-toolbar
        :columns="columns"
        :default-index="defaultIndex"
        @confirm="change"
        @cancel="showPicker = false"
      >
      <template #option="{ text }">
        <div class="van-multi-ellipsis--l2">{{ text }}</div>
      </template>
    </van-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "ClassSelect",
  model: {
    props: 'value',
    event: 'change',
  },
  props: {
    value: {type: String},
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    btnStateComputed: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    columns() {
      return this.detail?.courseDetailMFlightManageWebVos?.map(item => ({
        text: `${item.interviewClassName} ${item.interviewStartTime}`,
        value: item.id,
      }))
    },
    name() {
      const item = this.detail?.courseDetailMFlightManageWebVos?.find(item => item.id === this.value);
      if (item)
        return `${item.interviewClassName} ${item.interviewStartTime}`
      return ''
    },
    defaultIndex() {
      return this.detail?.courseDetailMFlightManageWebVos?.findIndex(item => item.id === this.value) || 0
    }
  },
  data() {
    return {
      showPicker: false,
      disabled: !(this.btnStateComputed.canClick && this.btnStateComputed.type === 0)
    }
  },
  methods: {
    showPop() {
      if (this.disabled) return
      this.showPicker = true
    },
    change(val) {
      this.$emit('change', val.value)
      this.showPicker = false
    }
  },
}
</script>

<style scoped lang="less">
  .class-select {
    background: #fff;
    font-size: 14px;
    padding: 0.2rem 0.4rem;
    color: #333;
    margin-top: 0.2rem;
    &-select {
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px 0 20px;
      background: #F2F2F2;
      margin: 10px 0;
      border: 1px solid transparent;
      position: relative;
      &.active {
        color: #FF3F47;
        background: #FDEFEF;
        border-color: #FF7773;
      }
    }
    &-tip {
      color: #FF3F47;
    }
    .price {
      color: #FF3F47;
      height: 40px;
      line-height: 40px;
      display: flex;
      padding: 10px 0;
      font-size: 20px;
      color: #FF3F47;
      font-weight: bold;
    }
  }
</style>